export enum PHN_AUTH_EVENT {
  INIT = "INIT_AUTHENTICATION",
  TOKEN_RECEIVED = "TOKEN_RECEIVED",
  TOKEN_RECEIVED_ERROR = "TOKEN_RECEIVED_ERROR",
  PREPARE_LOGOUT = "PREPARE_LOGOUT",
  PREPARE_LOGIN_WITH_REDIRECT = "PREPARE_LOGIN_WITH_REDIRECT",
  PREPARE_GET_TOKEN_SILENTLY = "PREPARE_GET_TOKEN_SILENTLY",
  LEGACY_LOGOUT = "LEGACY_LOGOUT",
  LOGOUT_DEFAULT_PREVENTED = "LOGOUT_DEFAULT_PREVENTED",
  LOGIN_DEFAULT_PREVENTED = "LOGIN_DEFAULT_PREVENTED",
  ACCOUNT_LOGIN = "ACCOUNT_LOGIN",
  ACCOUNT_LOGIN_DEFAULT_PREVENTED = "ACCOUNT_LOGIN_DEFAULT_PREVENTED",
  UPDATED_USER_STATE = "UPDATED_USER_STATE",
  UPDATED_USER_STATE_ERROR = "UPDATED_USER_STATE_ERROR",
  UNKNOWN = "UNKNOWN",
}

export interface PhnAuthEvent extends CustomEvent {
  detail: PhnAuthEventDetail;
}

export interface PhnAuthEventDetail {
  eventType: PHN_AUTH_EVENT;
  state?: string;
  token?: string;
  error?: Error;
}

export const PHN_AUTH_EVENT_NAME = "PHN_AUTHENTICATION";

export function dispatchAuthEvent(detail?: PhnAuthEventDetail): void {
  window.dispatchEvent(
    new CustomEvent(PHN_AUTH_EVENT_NAME, { detail }) as PhnAuthEvent,
  );
}

export function dispatchLegacyGetTokenEvent(token: string): void {
  window.dispatchEvent(
    new CustomEvent("getToken", {
      detail: { token },
    }),
  );
}
